import { createSelector } from 'reselect';
import { selectFeatureToggleMap } from 'selectors/navigation/util';

export const createSelectorForNumberSetting = (
  flag,
  defaultValue,
  validateWholePositiveNumber = false,
) =>
  createSelector([selectFeatureToggleMap], featureToggleMap => {
    const value = Number(featureToggleMap[flag]);
    if (validateWholePositiveNumber) {
      return Number.isInteger(value) && value > 0 ? value : defaultValue;
    }
    return value || defaultValue;
  });

export const createSelectorForTextSetting = (flag, defaultValue, opts) => {
  const defaultOnEmptyString = opts?.defaultOnEmptyString;
  return createSelector([selectFeatureToggleMap], featureToggleMap => {
    const value = featureToggleMap[flag];
    // Allows users to pick empty String by default - these cases would default when
    // undefined/null, as in "Remove Value" clicked in the Customer Config UI.
    if (defaultOnEmptyString) {
      return value || defaultValue;
    }
    return value ?? defaultValue;
  });
};

export const createSelectorForFlag = flag =>
  createSelector(
    [selectFeatureToggleMap],
    featureToggleMap => featureToggleMap[flag] === 'true',
  );
